<template>
    <svg width="200" height="55" viewBox="0 0 200 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M157.072 27.1584L152.637 21.2505L146.969 25.5555L130.192 38.4248C130.192 38.4248 130.192 38.4705 130.238 38.4705C130.238 38.4705 131.746 42.0428 
                134.718 44.5159"
            fill="url(#paint0_linear)"
        />
        <path
            d="M67.7475 54.9575H66.9246C61.9876 54.9575 58.0105 50.8815 58.0105 45.8437V15.5254H58.8333C63.7704 15.5254 67.7475 19.6014 67.7475 24.6392V54.9575Z"
            fill="url(#paint1_linear)"
        />
        <path
            d="M47.7249 9.80078C46.9935 7.73987 45.805 5.86215 44.2964 4.30502C42.7879 2.79368 40.9136 1.55713 38.8565 0.824365C37.3022 0.320586 35.7023 0 33.9652 0H0C0 
                5.40417 4.34279 9.75498 9.69127 9.75498H20.2054H33.9194C33.9651 9.75498 34.0109 9.75498 34.0566 9.75498C35.7937 9.80078 37.3937 10.2588 38.7651 11.0373C39.4965 
                11.4495 40.1822 11.9991 40.7765 12.5945C42.5136 14.3806 43.6107 16.8079 43.6107 19.51C43.6107 22.212 42.5136 24.6393 40.7765 26.4255C40.1822 27.0208 39.4965 
                27.5704 38.7651 27.9826C37.4394 28.7612 35.8394 29.2649 34.1937 29.2649C35.7937 29.2192 37.348 28.9444 38.7651 28.4406C40.8222 27.7078 42.6964 26.5171 44.205 
                24.9599C45.7135 23.4486 46.9021 21.5709 47.6335 19.4642C48.1821 17.9528 48.4563 16.3041 48.4563 14.5638C48.5478 12.9608 48.2735 11.3121 47.7249 9.80078Z"
            fill="url(#paint2_linear)"
        />
        <path
            d="M40.8678 12.6406C40.2735 12.0453 39.5878 11.4957 38.8564 11.0835C37.485 10.2592 35.8393 9.75537 34.1479 9.75537C35.4279 9.80117 36.6164 10.3507 37.4393 
                11.2209C38.3078 12.1369 38.8564 13.3276 38.8564 14.7016C38.8564 16.0297 38.3078 17.2663 37.4393 18.1822C36.5707 19.0524 35.3365 19.602 34.0108 
                19.602H24.2738H20.251H16.5939H14.5825C15.9082 19.602 17.1425 20.1515 18.011 21.0217L25.2338 29.3111H33.9651C34.0565 29.3111 34.1479 29.3111 34.2393 29.3111C35.9307 
                29.2653 37.485 28.8074 38.8107 28.0288C39.5421 27.6166 40.2278 27.067 40.8221 26.4717C42.5592 24.6855 43.6563 22.2582 43.6563 19.5562C43.6563 16.8541 42.6049 14.4268 
                40.8678 12.6406Z"
            fill="url(#paint3_radial)"
        />
        <path
            d="M26.2395 29.3106L18.4682 21.4334C17.5082 19.922 19.3824 19.6015 19.3824 19.6015L14.5368 19.5557C13.2111 19.5557 11.9768 20.1052 11.1083 20.9754C10.2397 21.8914 
                9.69116 23.0821 9.69116 24.4561C9.69116 25.7842 10.2397 27.0207 11.1083 27.9367L12.5254 29.3564L35.1993 52.1181C38.9935 55.9193 45.1191 55.9193 48.9134 
                52.1181L26.2395 29.3106Z"
            fill="url(#paint4_linear)"
        />
        <path
            d="M63.0846 12.7319C66.5588 12.7319 69.3931 9.89238 69.3931 6.36593C69.3931 2.83948 66.5588 0 63.0846 0C59.6104 0 56.7761 2.83948 56.7761 6.36593C56.7761 9.89238 
                59.5647 12.7319 63.0846 12.7319Z"
            fill="url(#paint5_linear)"
        />
        <path
            d="M130.238 38.4706C130.238 38.4706 130.238 38.4248 130.192 38.4248L128.455 39.7529L133.027 45.8441L134.718 44.5159C131.747 42.0428 130.238 38.4706 130.238 38.4706Z"
            fill="url(#paint6_linear)"
        />
        <path
            d="M160.363 31.8758C153.597 34.0741 152.912 38.9745 152.912 38.9745C152.409 41.2186 151.083 43.1421 148.934 44.7908C146.42 46.7143 143.769 47.5387 140.98 47.2181C138.603 
                46.9891 136.592 46.119 134.763 44.5618L134.718 44.516C131.746 42.0429 130.238 38.4707 130.238 38.4707C130.238 38.4707 130.238 38.4249 130.192 38.4249C129.323 36.364 
                129.141 34.3031 129.461 32.2422C129.963 29.5401 131.335 27.3418 133.666 25.5556C135.998 23.7695 138.466 22.991 141.163 23.2199C143.312 23.4031 145.186 24.1817 146.969 
                25.5556C146.969 25.5556 152.134 29.3569 150.306 32.4254L157.071 27.1586L158.214 26.2884L156.157 23.5863C152.729 19.1439 148.569 16.4876 143.677 15.6175C138.512 14.7015 
                133.666 16.0754 129.186 19.5103C124.706 22.991 122.192 27.3876 121.689 32.6085C121.278 37.6005 122.786 42.4093 126.169 46.8059C129.552 51.2483 133.758 53.9046 138.786 
                54.6832C143.952 55.5992 148.843 54.1794 153.369 50.6988C156.934 47.9967 159.22 44.7908 160.18 41.3102C161.049 38.2417 161.094 35.0358 160.363 31.8758Z"
            fill="url(#paint7_linear)"
        />
        <path
            d="M176.546 36.5471C176.043 36.5471 175.494 36.4555 174.992 36.2265C172.934 35.3563 171.974 32.9748 172.889 30.9139C173.072 30.5017 174.626 26.9295 178.329 
                23.861C181.849 21.0215 187.883 18.1362 196.888 20.6551C199.037 21.2505 200.271 23.4946 199.631 25.6471C199.037 27.7996 196.797 29.0362 194.648 28.4408C190.123 
                27.1585 186.283 27.708 183.311 30.1353C181.163 31.9215 180.203 34.0282 180.203 34.0282C179.609 35.6311 178.1 36.5471 176.546 36.5471Z"
            fill="url(#paint8_linear)"
        />
        <path
            d="M180.202 54.9575H179.334C174.397 54.9575 170.42 50.8815 170.42 45.8437V15.5254H171.243C176.18 15.5254 180.157 19.6014 180.157 24.6392V54.9575H180.202Z"
            fill="url(#paint9_linear)"
        />
        <path
            d="M99.4725 54.4084L99.7925 54.271L88.867 21.6628C87.267 16.9456 82.2842 14.4267 77.6672 16.0296L77.3472 16.167L88.2727 48.7752C89.827 53.5382 94.8097 56.0571 
                99.4725 54.4084Z"
            fill="url(#paint10_linear)"
        />
        <path
            d="M115.609 16.0291C110.992 14.3804 106.009 16.8993 104.409 21.6623L95.3582 48.6831C95.3124 48.8205 95.0839 49.3243 94.9924 49.5075C92.981 53.2629 90.5582 52.4844 
                90.5582 52.4844C91.9296 53.8125 93.4382 54.3621 93.4382 54.3621L93.8039 54.4995C98.421 56.1482 103.404 53.5835 105.004 48.8663L115.929 16.2581L115.609 16.0291Z"
            fill="url(#paint11_linear)"
        />
        <defs>
            <linearGradient id="paint0_linear" x1="148.984" y1="28.6017" x2="127.685" y2="45.152" gradientUnits="userSpaceOnUse">
                <stop offset="0.4523" stop-color="#28A5DE" />
                <stop offset="0.9975" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint1_linear" x1="62.8859" y1="16.9371" x2="62.8859" y2="56.9977" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint2_linear" x1="0.858728" y1="-1.83444" x2="49.6717" y2="21.098" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <radialGradient id="paint3_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.9643 11.2692) rotate(44.9812) scale(45.258 45.5228)">
                <stop stop-color="#3ABDB1" />
                <stop offset="0.7261" stop-color="#2861AE" />
            </radialGradient>
            <linearGradient id="paint4_linear" x1="12.3997" y1="21.8277" x2="49.7027" y2="56.7883" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint5_linear" x1="56.5601" y1="1.3254" x2="74.8931" y2="15.3831" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint6_linear" x1="154.885" y1="24.2544" x2="127.436" y2="45.2412" gradientUnits="userSpaceOnUse">
                <stop offset="0.4523" stop-color="#28A5DE" />
                <stop offset="0.9975" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint7_linear" x1="126.956" y1="50.2995" x2="151" y2="24.9183" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.7707" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint8_linear" x1="198.355" y1="20.4959" x2="177.455" y2="31.0095" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.5015" stop-color="#28A5DE" />
                <stop offset="0.9975" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint9_linear" x1="175.318" y1="16.9385" x2="175.318" y2="59.6209" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="1" stop-color="#28A5DE" />
            </linearGradient>
            <linearGradient id="paint10_linear" x1="79.7986" y1="13.4605" x2="97.8131" y2="57.9238" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.599" stop-color="#28A5DE" />
                <stop offset="0.9975" stop-color="#2861AE" />
            </linearGradient>
            <linearGradient id="paint11_linear" x1="94.4861" y1="60.9128" x2="115.447" y2="-2.38061" gradientUnits="userSpaceOnUse">
                <stop stop-color="#34D2C4" />
                <stop offset="0.5631" stop-color="#33AFCA" />
                <stop offset="0.8138" stop-color="#28A5DE" />
                <stop offset="0.9975" stop-color="#2861AE" />
            </linearGradient>
        </defs>
    </svg>
</template>
